/**
 * Internal dependencies
 */
import { createAction } from '../action-creators';
import { RootState } from '../types';
import {
	SET_AUTH_ERROR,
	SET_AUTH_LOADING,
	SET_AUTH_REFERRER,
	SET_AUTH_REMEMBER,
	SET_AUTH_TOKEN,
	SET_USER,
} from '../actionTypes';

export const setUser = createAction<RootState['auth']['user']>(SET_USER);

export const setAuthError =
	createAction<RootState['auth']['error']>(SET_AUTH_ERROR);

export const setAuthToken =
	createAction<RootState['auth']['token']>(SET_AUTH_TOKEN);

export const setAuthReferrer =
	createAction<RootState['auth']['referrer']>(SET_AUTH_REFERRER);

export const setAuthRemember =
	createAction<RootState['auth']['remember']>(SET_AUTH_REMEMBER);

export const setAuthLoading =
	createAction<RootState['auth']['loading']>(SET_AUTH_LOADING);
